import { Form, Formik } from 'formik';
import CustomTextArea from '../../../components/text-area/textArea';
import ModalComponent from '../../../components/modal/modal';
import ModalBody from '../../../components/modal/modalBodyComponent';
import ModalFooterComponent from '../../../components/modal/modalFooterComponent';
import { usePostBrokerSsoConfigurationKey, useWealthlaneIdentityApi } from '../../../hooks';
import { type ModalStatusType } from '../../../types/common';
import _ from 'lodash';
import InitialValuesForm from '../../../constants/initialValues';
import CustomDatePicker from '../../../components/date-picker/customDatePicker';
interface AddKeyManagementModalType {
  isModalOpen: boolean;
  closeModal: () => void;
  id?: string;
  initialData?: any;
  modalStatus?: ModalStatusType;
  setModalStatus?: (status: ModalStatusType) => void;
  brokerSsoConfigurationId?: string;
}

const AddKeyManagementModal = ({
  isModalOpen,
  closeModal,
  id,
  initialData,
  modalStatus,
  setModalStatus,
  brokerSsoConfigurationId,
}: AddKeyManagementModalType): JSX.Element => {
  const { handleRequest } = useWealthlaneIdentityApi();
  const { mutate, isLoading } = usePostBrokerSsoConfigurationKey(
    handleRequest,
    () => {
      closeModal();
    },
    initialData?.id
  );

  return (
    <Formik
      enableReinitialize
      initialValues={
        initialData && modalStatus !== 'Add' ? initialData.data : InitialValuesForm.addKeyManagement
      }
      //   validationSchema={BROKER_SSO_CONFIGURATION_VALIDATION}
      onSubmit={(values) => {
        mutate({
          brokerSsoConfigurationId: brokerSsoConfigurationId ?? '',
          publicKey: values.publicKey,
          privateKey: values.privateKey,
          effectiveFrom: values.effectiveFrom,
          expiresAt: values.expiresAt !== '' ? values.expiresAt : null,
        });
      }}>
      {({ touched, handleChange, errors, values, setFieldValue, setFieldTouched }) => {
        return (
          <ModalComponent
            show={isModalOpen}
            closeModal={closeModal}
            loading={isLoading}
            size='md'
            valueEdited={modalStatus !== 'Add' && _.isEqual(values, initialData.data)}
            title={`${modalStatus} Key Management`}
            id={id}
            children={
              <Form id='brokerageSsoConfigurationForm'>
                <ModalBody id='modalBody'>
                  <CustomTextArea
                    label='Public Key'
                    name='publicKey'
                    id='publicKey'
                    onChange={handleChange}
                    errors={errors}
                    touched={touched}
                    inputType={modalStatus === 'View' ? 'View' : undefined}
                    disabled={modalStatus !== 'Add'}
                    rows='4'
                    required
                  />
                  <CustomTextArea
                    label='Private Key'
                    name='privateKey'
                    id='privateKey'
                    onChange={handleChange}
                    errors={errors}
                    touched={touched}
                    inputType={modalStatus === 'View' ? 'View' : undefined}
                    disabled={modalStatus !== 'Add'}
                    rows='4'
                    required
                  />
                  <CustomDatePicker
                    label='Effective From'
                    name='effectiveFrom'
                    id='effectiveFrom'
                    onChange={handleChange}
                    setFieldValue={setFieldValue}
                    setFieldTouched={setFieldTouched}
                    errors={errors}
                    touched={touched}
                    errorValue={errors?.effectiveFrom}
                    touchedValue={touched?.effectiveFrom}
                    arrValue={values?.effectiveFrom}
                    // values={values}
                    defaultValue={new Date()}
                    disabled={modalStatus === 'View'}
                    fieldLabelName='test'
                    required
                  />
                  <CustomDatePicker
                    label='Expires At'
                    name='expiresAt'
                    id='expiresAt'
                    onChange={handleChange}
                    setFieldValue={setFieldValue}
                    setFieldTouched={setFieldTouched}
                    errors={errors}
                    touched={touched}
                    errorValue={errors?.expiresAt}
                    touchedValue={touched?.expiresAt}
                    arrValue={values?.expiresAt}
                    // values={values}
                    defaultValue={new Date()}
                    disabled={modalStatus === 'View'}
                    fieldLabelName='test'
                    required
                  />
                </ModalBody>
                <ModalFooterComponent
                  id='brokerageSsoConfigurationModalFooter'
                  modalStatus={modalStatus}
                  onCloseModal={() => {
                    closeModal();
                  }}
                  onEditModal={() => {
                    setModalStatus('Edit');
                  }}
                  valueChanged={modalStatus !== 'Add' && _.isEqual(values, initialData.data)}
                  loading={isLoading}
                />
              </Form>
            }
          />
        );
      }}
    </Formik>
  );
};

export default AddKeyManagementModal;
